import { ROLES } from "../constants/roles";

/**
 * Returns true if the logged-in user is an admin
 */
export const isUserAdmin = () => {
  const userRole = localStorage.getItem("user_role");
  if (
    userRole === "admin" ||
    userRole === "hospital_admin" ||
    userRole === ROLES.ADMIN
  ) {
    return true;
  }
  const token = localStorage.getItem("user_token");
  if (token) {
    try {
      const payload = JSON.parse(
        atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")),
      );
      const roles = [].concat(
        payload.role || [],
        payload.roles || [],
        payload.tokenRoles || [],
        payload.primaryRole || [],
      );
      return (
        roles.includes("admin") ||
        roles.includes("hospital_admin") ||
        roles.includes(ROLES.ADMIN)
      );
    } catch {
      return false;
    }
  }
  return false;
};

const isActingAsAdmin = () => {
  const userRole = localStorage.getItem("user_role");
  return (
    userRole === "admin" ||
    userRole === "hospital_admin" ||
    userRole === ROLES.ADMIN
  );
};

/**
 * Clears admin read-only stakeholder view keys from sessionStorage.
 */
export const clearAdminViewSession = () => {
  sessionStorage.removeItem("admin_selected_staff_id");
  sessionStorage.removeItem("admin_selected_role");
  sessionStorage.removeItem("admin_selected_staff_name");
};

/**
 * Returns true if the current session role is admin and a stakeholder is selected for read-only view.
 * Uses localStorage user_role (not JWT) so Switch Role into a working role exits this mode.
 */
export const isViewingAsAdmin = () => {
  const selectedStaffId = sessionStorage.getItem("admin_selected_staff_id");
  return Boolean(isActingAsAdmin() && selectedStaffId);
};

const MUTATION_PATTERNS = [
  /^[+]?\s*add\b/i,
  /^[+]?\s*create\b/i,
  /^[+]?\s*bulk\b/i,
  /^[+]?\s*edit\b/i,
  /^[+]?\s*update\b/i,
  /^[+]?\s*delete\b/i,
  /^[+]?\s*remove\b/i,
  /^[+]?\s*save\b/i,
  /^[+]?\s*submit\b/i,
  /^[+]?\s*confirm\b/i,
  /^[+]?\s*approve\b/i,
  /^[+]?\s*reject\b/i,
  /^[+]?\s*assign\b/i,
  /^[+]?\s*admit\b/i,
  /^[+]?\s*discharge\b/i,
  /^[+]?\s*start\b/i,
  /\bpayment\b/i,
  /^[+]?\s*pay\b/i,
  /^[+]?\s*take payment\b/i,
  /^[+]?\s*change\b/i,
  /^[+]?\s*new\b/i,
  /^[+]?\s*upload\b/i,
  /^[+]?\s*reschedule\b/i,
  /cancel appointment\b/i,
  /\bcancel\b/i,
  /^[+]?\s*book\b/i,
  /^[+]?\s*schedule\b/i,
  /^[+]?\s*generate\b/i,
  /^[+]?\s*send\b/i,
  /^[+]?\s*publish\b/i,
  /^[+]?\s*complete\b/i,
  /^[+]?\s*refund\b/i,
  /^[+]?\s*mark\b/i,
  /^[+]?\s*replace\b/i,
  /^[+]?\s*initiate\b/i,
  /^[+]?\s*fulfill\b/i,
  /^[+]?\s*dispense\b/i,
  /^[+]?\s*enable\b/i,
  /^[+]?\s*disable\b/i,
  /^[+]?\s*archive\b/i,
  /^[+]?\s*prescribe\b/i,
  /^[+]?\s*allocate\b/i,
  /^[+]?\s*transfer\b/i,
  /^[+]?\s*record\b/i,
  /^[+]?\s*collect\b/i,
  /^[+]?\s*order\b/i,
  /prescription$/i, // catches "OPD Prescription" and "IPD Prescription" (while NOT matching "View Prescription")
];

const READONLY_ALLOWED_PATTERNS = [
  /^view/i,
  /^calendar/i,
  /^table/i,
  /^clear/i,
  /^print/i,
  /^download/i,
  /^export/i,
  /^done/i,
  /^back/i,
  /^close/i,
  /^go back/i,
  /^next/i,
  /^prev/i,
  /^history/i,
  /^filter/i,
  /^search/i,
  /^reset/i,
];

/**
 * Returns true if button text matches a mutation action that must be hidden for admins
 */
export const isActionBlockedForAdmin = (text) => {
  if (!text) return false;
  let str = "";
  if (typeof text === "string") {
    str = text;
  } else if (Array.isArray(text)) {
    str = text.map((t) => (typeof t === "string" ? t : "")).join(" ");
  } else if (typeof text === "object" && text?.props?.children) {
    return isActionBlockedForAdmin(text.props.children);
  }
  const t = str.trim();
  if (!t) return false;
  if (READONLY_ALLOWED_PATTERNS.some((p) => p.test(t))) {
    return false;
  }
  return MUTATION_PATTERNS.some((p) => p.test(t));
};
